<p-dialog class="paypal-modal" header="Header" [(visible)]="visible" [breakpoints]="{ '1080px': '75vw', '560px':'90vw' }" [style]="{ width: '50vw',maxWidth:'420px' }" (onHide)="onHide()" [modal]="true" [dismissableMask]="true">
  <ng-template pTemplate="header">
    <span>Pay with Card</span>
  </ng-template>
  <div #paypal></div>
</p-dialog>